"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.launchEvent = void 0;
const launchEvent = (e) => {
    const styleData = e.data;
    if (typeof window.ctConstants === 'undefined')
        return;
    const analyticsEvent = {};
    analyticsEvent.eventInfo = {
        type: window.ctConstants.trackEvent,
        eventAction: 'VTO style selected',
        eventLabel: styleData.styleName,
        eventValue: 1
    };
    analyticsEvent.category = {
        primaryCategory: `AIBA:${styleData.type}` //  primaryCategory: 'AIBA:<first-time/reapplied>'
    };
    console.log('***custom event VTO- ', analyticsEvent, e);
    window.digitalData.event.push(analyticsEvent);
};
exports.launchEvent = launchEvent;
